import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";

import { Icon } from "../../../Icon/Icon";
import { AllIconName } from "../../../Icon/types";

import { alpha } from "../../../../typography";

export enum TriggerTestIds {
  Component = "trigger",
}

type ContainerProps = {
  $opened?: boolean;
  $disabled?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  user-select: none;
  ${alpha.primaryActive.body3}
  cursor: ${({ $disabled }): string => ($disabled ? "not-allowed" : "pointer")};
  :hover {
    color: var(--color-secondary-800);
    svg {
      --main-color: var(--color-secondary-800);
    }
  }
  ${({ $disabled }): FlattenSimpleInterpolation =>
    $disabled
      ? css`
          color: var(--color-primary-200);
          svg {
            --main-color: var(--color-primary-200);
          }
          :hover {
            color: var(--color-primary-200);
            svg {
              --main-color: var(--color-primary-200);
            }
          }
        `
      : css``}
  ${({ $opened }): FlattenSimpleInterpolation =>
    $opened
      ? css`
          color: var(--color-secondary-800);
          svg {
            --main-color: var(--color-secondary-800);
          }
        `
      : css``}
`;

type Props = {
  id?: string;
  className?: string;
  testId?: string;
  opened?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
  iconName: AllIconName;
  label?: string;
};

export const Trigger: FC<Props> = ({
  id,
  className,
  testId,
  opened,
  disabled,
  onClick,
  iconName,
  label,
  onBlur,
}) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? TriggerTestIds.Component}
    $opened={opened}
    $disabled={disabled}
    onClick={(event) => !disabled && onClick?.(event)}
    tabIndex={0}
    onBlur={(event) => onBlur?.(event)}
  >
    <>
      <Icon iconName={iconName} plain />
      {label}
    </>
  </Container>
);
